module.exports = __webpack_public_path__ + "img/Shape-Pale-1.eaf7deb4.png";